import type { HighlightConfig } from './types';

import { add } from './add';
import { remove } from './remove';

// ----------------------------------------------------------------------------

function start(element: HTMLElement, find: string, config: HighlightConfig = {}): void {
    remove(element, config);
    add(element, find, config);
}

// ----------------------------------------------------------------------------

export { start };
